import { differenceInCalendarDays } from "date-fns";

export default function getDateDurationSinceDate(date) {
  const today = new Date();

  const daysSince = differenceInCalendarDays(today, date || today);

  if (typeof date === "undefined" || date === "" || daysSince === 0) {
    return "Today";
  } else if (daysSince <= 1) {
    return "1 day ago";
  } else if (daysSince < 7) {
    return `${daysSince} days ago`;
  } else if (daysSince >= 7 && daysSince < 14) {
    return "1 week ago";
  } else if (daysSince >= 14 && daysSince < 21) {
    return "2 weeks ago";
  } else if (daysSince >= 21 && daysSince < 28) {
    return "3 weeks ago";
  } else if (daysSince >= 28 && daysSince < 35) {
    return "4 weeks ago";
  } else if (daysSince >= 35) {
    return "Over 4 weeks ago";
  }
}
